import React, { useState, useEffect } from 'react'
import { List, Radio } from 'antd-mobile';
import { Select, Row, Col, Modal, Input } from 'antd';
import { isMobile } from "react-device-detect";
import { DownOutlined, CloseCircleOutlined } from '@ant-design/icons';

const RadioItem = Radio.RadioItem;
const { TextArea } = Input;
const { Option } = Select
export const SelectBox = (props) => {
  const [getValue, setValue] = useState({ value: '', label: '' });
  const [isModalVisible, setIsModalVisible] = useState(false);

  useEffect(() => {
    if (props.data !== null) {
      const filter_value = props.data.filter(e => e.value == props.value)
      setValue(filter_value[0]);
    }
  }, [props.value, props.data])

  const radio_onselect = (e) => {
    setValue(e);
    setIsModalVisible(false);
    if (props.onChange) {
      props.onChange(e.value);
    }
  }

  const clear_select = () => {
    setValue({ value: '', label: '' });
    if (props.onChange) {
      props.onChange('');
    }
  }

  return (
    (isMobile) ?
      (
        <>
          <div
            style={{ borderBottomStyle: 'groove', color: '#978897', fontVariant: 'tabular-nums', marginTop: '-10px' }}>
            <Row>
              <Col
                xs={{ span: 20 }}
                onClick={() => {
                  if (!props.disabled) {
                    setIsModalVisible(!isModalVisible);
                  }
                }}>
                <TextArea
                  style={{ fontSize: '12px' }}
                  value={(getValue !== undefined ? getValue.label : props.value)}
                  bordered={false}
                  autoSize
                  readOnly={true}
                />
              </Col>
              {
                (props.value?.toString().length > 0) ?
                  (
                    <Col
                      xs={{ span: 2 }} style={{ alignSelf: 'center' }}
                      onClick={() => {
                        if (!props.disabled) {
                          clear_select();
                        }
                      }}><CloseCircleOutlined />
                    </Col>
                  ) :
                  (
                    <Col xs={{ span: 2 }} style={{ alignSelf: 'center' }}></Col>
                  )
              }
              <Col
                xs={{ span: 2 }} style={{ alignSelf: 'center' }}
                onClick={() => {
                  if (!props.disabled) {
                    setIsModalVisible(!isModalVisible);
                  }
                }}><DownOutlined />
              </Col>
            </Row>
          </div>
          <Modal
            title="Options"
            centered
            closable
            maskClosable={true}
            footer={null}
            visible={isModalVisible}
            style={{ verticalAlign: 'bottom' }}
            bodyStyle={{ height: '15em' }}
            onCancel={(e) => {
              setIsModalVisible(false)
            }}
          >
            <div style={{ fontSize: '12px', height: '10em', maxHeight: '23em', overflowX: 'scroll' }}>
              {
                <List>
                  {
                    props.data && (
                      props.data.map(i => {
                        return (
                          <RadioItem
                            key={i.value}
                            checked={(getValue !== undefined ? getValue.value : '') === i.value}
                            onChange={() => {
                              radio_onselect(i)
                            }}>{i.label}
                          </RadioItem>
                        );
                      })
                    )
                  }
                </List>
              }
            </div>
          </Modal>
        </>
      ) :
      (
        <>
          <Select
            allowClear
            disabled={props.disabled ?? false}
            value={(getValue !== undefined ? getValue.value : props.value)}
            showSearch={props.showSearch}
            filterOption={props.filterOption}
            notFoundContent={props.notFoundContent}
            style={{ width: '100%' }}
            onChange={(val) => {
              props.onChange(val);
            }}>
            {
              props.data && (
                props.data.map((item, i) => {
                  return (
                    <Option value={item.value} key={i}>{item.label}</Option>
                  );
                })
              )
            }
          </Select>
        </>
      )
  )
}
